import type { TourProgressAdapter } from '@nucleus-commerce/admin-kit/tour';
import {
  deletePlatformV1MeTours,
  getPlatformV1MeTours,
  putPlatformV1MeToursTourId,
} from '@nucleus-commerce/api-client/platform';

/** `GET/PUT/DELETE /platform/v1/me/tours`: the operator's own tour progress. */
export const platformTourProgress: TourProgressAdapter = {
  list: () => getPlatformV1MeTours(),
  save: (tourId, body) => putPlatformV1MeToursTourId({ tourId }, body),
  reset: async (tourId) => {
    await deletePlatformV1MeTours(tourId ? { tourId } : undefined);
  },
};
